import React, { useEffect, useState } from "react";
import { collection, doc, getDoc, getDocs, orderBy, query, Timestamp } from "firebase/firestore";
import { Link, useLocation } from "react-router-dom";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import "./style.css";

interface PressRelease {
  id: string;
  title: string;
  content: string;
  date: Timestamp;
}

export function ComunicateDePresaPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [pressReleases, setPressReleases] = useState<PressRelease[]>([]);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const headerSnap = await getDoc(doc(db, "site_content", "press_releases_header"));
      if (headerSnap.exists()) {
        setHeaderImage(headerSnap.data().header_image || "");
      }

      const q = query(collection(db, "press_releases"), orderBy("date", "desc"));
      const snap = await getDocs(q);
      setPressReleases(
        snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })) as PressRelease[]
      );
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />
      {headerImage && (
        <div
          className="press-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}
      <div className="page-content">
        <h1>Știri</h1>
        <div className="press-list">
          {pressReleases.map((release) => (
            <Link
              key={release.id}
              to={`/comunicate/${release.id}${
                new URLSearchParams(location.search).get("admin") === "true" ? "?admin=true" : ""
              }`}
              className="press-card"
            >
              <h3>{release.title}</h3>
              <p className="press-date">
                {release.date?.toDate?.().toLocaleDateString("ro-RO", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
